module.exports = __webpack_public_path__ + "img/checked.da188ccb.png";